import {
  applyChosen
} from './modules/selects_helper';
import {
  defaultCountryCode
} from './modules/country_code';

$(function () {

  let singleSelects = $('.chosen-single-select');
  let primarySingleSelects = $('.chosen-primary-single-select');
  let multiSelects = $('.chosen-multi-select');
  let singleSelectsImage = $('.chosen-image');

  applyChosen(singleSelects);
  applyChosen(multiSelects);
  applyChosen(singleSelectsImage);

  singleSelectsImage.chosenImage();

  primarySingleSelects.chosen({
    width: '100%',
    include_group_label_in_selected: true,
    placeholder_text_single: I18n.t('js.all')
  });

  defaultCountryCode(singleSelectsImage, singleSelectsImage.data('countrycode'));
});


// WEBPACK FOOTER //
// ./app/webpacker/src/js/chosen_custom.js